import { Component } from 'react';
import WLogForm from './WLogForm';
import WLogModule from './WLogModule';	
import { GeneralObserver } from './Observer';
import { LABELS } from '../global/constants';

class WLogsModule extends Component {

	constructor(props) {
		super(props);

		this.state = {
			parentID: this.props.parentID,
			controller: this.props.controller,
			logs: [],
			status: 'default',
		}

		this.moduleName = 'wlogs';
		this.bindFunctions();
	}
	
	bindFunctions() {
		this.reactFn = this.reactFn.bind(this);
	}


	componentDidMount() {
		this.initialSetup();
	}

	// Setup observer and subscribe to events from controller
    // Fetch data from controller 
	initialSetup() {
		const ctrl = this.state.controller;
		this.observer = new GeneralObserver(this.reactFn);

		ctrl.addObserver(this.observer);
		ctrl.fetchData();
		
		this.setState({
			controller: ctrl,
		});
	}

	// Reacts to controller events
	// Sets controller and logs
	reactFn() {
		const ctrl = this.state.controller;
		const newData = ctrl.getLogs();

		this.setState({
			controller: ctrl,
			logs: newData
		});
	}	

	// Gets the next set of logs
	// Calls controller loadMore fn
	getMore() {
		const ctrl = this.state.controller;
		
		if ( ctrl.getHasMore() ) {
			ctrl.loadMore();
		}
	}

	render() {
		const ctrl = this.state.controller;
		const logs = this.state.logs;
		const hasLogs = logs && logs.length > 0;
		const hasMore = ctrl.getHasMore();

	    return (
	    		<div className={ this.moduleName }>
	    			{
						hasLogs &&
							Object.keys(logs).map(currentKey => (
								<WLogModule 
									key={currentKey} 
									data={ logs[currentKey] }
									animate={ logs[currentKey].animate }
								></WLogModule>
							))	
			    	}

					<WLogForm 
						boardId={this.state.parentID}
						newWLogSuccess={this.newWLogSuccess} 
						controller={ ctrl }
					/>
					
					{ hasMore && <button onClick={ () => { this.getMore() } }>{LABELS.loadMore}</button> }
		    	</div>
	    );
  	}
}

export default WLogsModule;
